var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinNotifyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#C4E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0475 34.0848C28.2506 34.0848 34.0899 28.2455 34.0899 21.0424C34.0899 13.8393 28.2506 8 21.0475 8C13.8444 8 8.00513 13.8393 8.00513 21.0424C8.00513 28.2455 13.8444 34.0848 21.0475 34.0848Z",
    fill: "#FEC200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3361 12.0889L19.9572 18.4213C19.2338 18.7201 18.6991 19.2863 18.4212 19.9573L12.094 17.331C13.0428 15.0402 14.8671 13.1111 17.3361 12.0889Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0062 17.3362L23.6685 19.9573C23.3697 19.2339 22.8036 18.6992 22.1326 18.4213L24.7536 12.0889C27.0497 13.0377 28.984 14.8619 30.0062 17.3362Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9571 23.6687L17.3361 30.0012C15.04 29.0524 13.1057 27.2281 12.0835 24.7591L18.416 22.138C18.72 22.8562 19.2862 23.3909 19.9571 23.6687Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.001 24.7538C29.0522 27.0499 27.2279 28.979 24.7536 30.0012L22.1326 23.6687C22.856 23.3699 23.3907 22.8037 23.6685 22.1328L30.001 24.7538Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4214 19.9573C18.1435 20.6335 18.1226 21.4094 18.4214 22.1328L12.0889 24.7538C11.0667 22.2848 11.1453 19.627 12.0941 17.331L18.4214 19.9573Z",
    fill: "#E6E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7539 12.0889L22.1276 18.4214C21.4514 18.1435 20.6755 18.1226 19.9521 18.4214L17.3311 12.0889C19.8053 11.0667 22.4631 11.1401 24.7539 12.0889Z",
    fill: "#E6E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0064 17.3362C31.0286 19.8053 30.95 22.463 30.0012 24.7591L23.6687 22.1328C23.9465 21.4565 23.9675 20.6807 23.6687 19.9573L30.0064 17.3362Z",
    fill: "#E6E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1327 23.6687L24.7538 30.0012C22.2847 31.0234 19.6322 30.95 17.3362 29.9959L19.9572 23.6635C20.6335 23.9465 21.4093 23.9675 22.1327 23.6687Z",
    fill: "#E6E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8875 9.83998C22.8875 10.857 21.0475 14.1857 21.0475 14.1857C21.0475 14.1857 19.2075 10.857 19.2075 9.83998C19.2075 8.82301 20.0305 8 21.0475 8C22.0645 8 22.8875 8.82301 22.8875 9.83998Z",
    fill: "#009AFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.7146 9.06415C22.7094 9.07987 22.7041 9.09036 22.6989 9.10608C22.1642 10.663 19.931 10.663 19.3964 9.10608C19.3911 9.09036 19.3859 9.07987 19.3806 9.06415C19.2705 9.30004 19.2024 9.56215 19.2024 9.83998C19.2024 10.857 21.0424 14.1857 21.0424 14.1857C21.0424 14.1857 22.8824 10.857 22.8824 9.83998C22.8876 9.56215 22.8247 9.30529 22.7146 9.06415Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0475 23.8836C19.4801 23.8836 18.2063 22.6098 18.2063 21.0424C18.2063 19.475 19.4801 18.2012 21.0475 18.2012C22.6149 18.2012 23.8888 19.475 23.8888 21.0424C23.8888 22.6098 22.6149 23.8836 21.0475 23.8836Z",
    fill: "#5D5B68"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.0961 22.8352C20.5287 22.8352 19.2548 21.5613 19.2548 19.9939C19.2548 19.4802 19.3964 18.9979 19.6323 18.5838C18.7778 19.0766 18.2012 19.9939 18.2012 21.0476C18.2012 22.615 19.475 23.8888 21.0424 23.8888C22.0961 23.8888 23.0134 23.3122 23.5062 22.4577C23.0921 22.6989 22.6098 22.8352 22.0961 22.8352Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0477 22.0908C21.6267 22.0908 22.0961 21.6214 22.0961 21.0424C22.0961 20.4634 21.6267 19.994 21.0477 19.994C20.4687 19.994 19.9993 20.4634 19.9993 21.0424C19.9993 21.6214 20.4687 22.0908 21.0477 22.0908Z",
    fill: "#AAB2BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4178 21.5666C32.7073 21.5666 32.942 21.3319 32.942 21.0424C32.942 20.7529 32.7073 20.5182 32.4178 20.5182C32.1283 20.5182 31.8936 20.7529 31.8936 21.0424C31.8936 21.3319 32.1283 21.5666 32.4178 21.5666Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67753 21.5666C9.96705 21.5666 10.2017 21.3319 10.2017 21.0424C10.2017 20.7529 9.96705 20.5182 9.67753 20.5182C9.38802 20.5182 9.15332 20.7529 9.15332 21.0424C9.15332 21.3319 9.38802 21.5666 9.67753 21.5666Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0892 13.5304C29.3787 13.5304 29.6134 13.2957 29.6134 13.0062C29.6134 12.7167 29.3787 12.482 29.0892 12.482C28.7996 12.482 28.5649 12.7167 28.5649 13.0062C28.5649 13.2957 28.7996 13.5304 29.0892 13.5304Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0064 29.608C13.2959 29.608 13.5306 29.3733 13.5306 29.0838C13.5306 28.7943 13.2959 28.5596 13.0064 28.5596C12.7169 28.5596 12.4822 28.7943 12.4822 29.0838C12.4822 29.3733 12.7169 29.608 13.0064 29.608Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0476 32.942C21.3372 32.942 21.5719 32.7073 21.5719 32.4178C21.5719 32.1283 21.3372 31.8936 21.0476 31.8936C20.7581 31.8936 20.5234 32.1283 20.5234 32.4178C20.5234 32.7073 20.7581 32.942 21.0476 32.942Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0064 13.5304C13.2959 13.5304 13.5306 13.2957 13.5306 13.0062C13.5306 12.7167 13.2959 12.482 13.0064 12.482C12.7169 12.482 12.4822 12.7167 12.4822 13.0062C12.4822 13.2957 12.7169 13.5304 13.0064 13.5304Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0892 29.608C29.3787 29.608 29.6134 29.3733 29.6134 29.0838C29.6134 28.7943 29.3787 28.5596 29.0892 28.5596C28.7996 28.5596 28.5649 28.7943 28.5649 29.0838C28.5649 29.3733 28.7996 29.608 29.0892 29.608Z",
    fill: "#FF4823"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.507 12.1517C9.3315 14.4845 8 17.6088 8 21.0476C8 28.2503 13.8397 34.09 21.0424 34.09C24.4812 34.09 27.6055 32.7585 29.9382 30.583C30.2161 30.2947 30.4834 29.9959 30.7298 29.6814C28.5019 31.4532 25.6869 32.5173 22.615 32.5173C15.4123 32.5173 9.57263 26.6776 9.57263 19.475C9.57263 16.4083 10.6315 13.5881 12.4086 11.3602C12.0993 11.6065 11.8005 11.8739 11.507 12.1517Z",
    fill: "#1A1A1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinNotifyIcon);
export default __webpack_public_path__ + "static/media/spin-notify-icon.20a6a9efa815d2e1b3edb8ba9af2b176.svg";
export { ForwardRef as ReactComponent };